export function useRequestProfileReloadsWithList({
  onEntityReload,
  onLoadCounters,
  onReloadList,
  onReloadListExtra,
  onReloadOpenActivities,
}) {
  async function handleEntityReloadWithList() {
    onReloadList?.()

    return onEntityReload()
  }

  async function handleReloadOpenActivitiesWithList() {
    onReloadListExtra?.()

    return onReloadOpenActivities()
  }

  async function handleLoadCountersWithList(sections) {
    onReloadListExtra?.()

    return onLoadCounters(sections)
  }

  return {
    handleEntityReloadWithList,
    handleLoadCountersWithList,
    handleReloadOpenActivitiesWithList,
  }
}
